import { Flex, Icon, type FlexProps } from '@chakra-ui/react'
import type { ElementType } from 'react'

export type DecoHue = 'green' | 'blue' | 'peach'

const SIZES = {
  sm: { box: 8, icon: 4, radius: 'md' },
  md: { box: 10, icon: 5, radius: 'md' },
  lg: { box: 14, icon: 7, radius: 'lg' },
} as const

/** A rounded square with a decorative-palette tint behind an icon. Decorative by default (`aria-hidden`). */
export function IconTile({
  icon,
  hue = 'green',
  size = 'md',
  ...rest
}: { icon: ElementType; hue?: DecoHue; size?: keyof typeof SIZES } & Omit<FlexProps, 'children'>) {
  const s = SIZES[size]
  return (
    <Flex
      aria-hidden
      flexShrink={0}
      align='center'
      justify='center'
      w={s.box}
      h={s.box}
      borderRadius={s.radius}
      bg={`deco.${hue}.bg`}
      color={`deco.${hue}.fg`}
      {...rest}
    >
      <Icon as={icon} boxSize={s.icon} />
    </Flex>
  )
}
